import { render, staticRenderFns } from "./IdeaScoreCheckmarkText.vue?vue&type=template&id=d0f3d70e&scoped=true"
import script from "./IdeaScoreCheckmarkText.vue?vue&type=script&lang=js"
export * from "./IdeaScoreCheckmarkText.vue?vue&type=script&lang=js"
import style0 from "./IdeaScoreCheckmarkText.vue?vue&type=style&index=0&id=d0f3d70e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f3d70e",
  null
  
)

export default component.exports